var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 5.125V6.75H17.375V5.125H2.625ZM17.625 8.24439C18.3258 8.18124 18.875 7.59226 18.875 6.875V5C18.875 4.24061 18.2594 3.625 17.5 3.625H2.5C1.74061 3.625 1.125 4.24061 1.125 5V6.875C1.125 7.59226 1.67419 8.18124 2.375 8.24439V15C2.375 15.3647 2.51987 15.7144 2.77773 15.9723C3.03559 16.2301 3.38533 16.375 3.75 16.375H16.25C16.6147 16.375 16.9644 16.2301 17.2223 15.9723C17.4801 15.7144 17.625 15.3647 17.625 15V8.24439ZM16.125 8.25H3.875V14.875H16.125V8.25ZM7.375 10.625C7.375 10.2108 7.71079 9.875 8.125 9.875H11.875C12.2892 9.875 12.625 10.2108 12.625 10.625C12.625 11.0392 12.2892 11.375 11.875 11.375H8.125C7.71079 11.375 7.375 11.0392 7.375 10.625Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.0823930ba1be81f8ba0ff844e1d88fb5.svg";
export { ForwardRef as ReactComponent };